var map = {
	"./terms-de.vue": [
		"qO2k",
		3
	],
	"./terms-en.vue": [
		"fASz",
		2
	],
	"./terms-es.vue": [
		"SjdR",
		1
	],
	"./terms-fr.vue": [
		"u+1q",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "z8T9";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages/terms lazy ^\.\/terms\-.*\.vue$
// module id = z8T9
// module chunks = 17